<script setup lang="ts">
import { DropdownMenuTrigger } from 'reka-ui';

withDefaults(
    defineProps<{
        asChild?: boolean;
    }>(),
    {
        asChild: true,
    },
);
</script>

<template>
    <DropdownMenuTrigger :as-child="asChild">
        <slot>
            <div
                class="hover:bg-muval-gray-5 inline-flex cursor-pointer rounded-md py-1 transition"
                :class="$attrs.class"
            >
                <SvgIcon
                    name="system-kebab-menu"
                    class="text-muval-gray-1 h-6 w-6"
                />
            </div>
        </slot>
    </DropdownMenuTrigger>
</template>
